import { render, staticRenderFns } from "./foursale.vue?vue&type=template&id=5ad12bfe"
import script from "./foursale.vue?vue&type=script&lang=js"
export * from "./foursale.vue?vue&type=script&lang=js"
import style0 from "./foursale.vue?vue&type=style&index=0&id=5ad12bfe&prod&lang=css"
import style1 from "./foursale.vue?vue&type=style&index=1&id=5ad12bfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports